export enum RemindersPopupActionSource {
    DismissAll = 'DismissAll',
    PopupSettingOff = 'PopupSettingOff',
    NoReminders = 'NoReminders',
    PopupCloseButton = 'PopupCloseButton',
    MainWindowClose = 'MainWindowClose',
    EscapeKey = 'EscapeKey',
}
